// Module
var code = "<tr> <td><%- pid %></td> <td><%- networkId %></td> <td><%- geo === '' ? 'Not specified' : geo %></td> <td><%- count %></td> <td><%- kw1 ? kw1 : '' %></td> <td><%- kw2 ? kw2 : '' %></td> </tr> ";
// Exports
module.exports = code;